module.exports = __webpack_public_path__ + "img/heritage-avenida-liberdade-hotel.a9ec46af.jpg";